'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _FormInput = require('../FormInput');

var _FormInput2 = _interopRequireDefault(_FormInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App');

var UserContactsBase = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(UserContactsBase, _React$PureComponent);

    function UserContactsBase(props, anonymous) {
        (0, _classCallCheck3.default)(this, UserContactsBase);

        var _this = (0, _possibleConstructorReturn3.default)(this, (UserContactsBase.__proto__ || (0, _getPrototypeOf2.default)(UserContactsBase)).call(this, props));

        _this.companyInfo = function () {
            var readonly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            return _react2.default.createElement(
                'div',
                { className: 'row' },
                _this.createInput('companyName', Resx.App.Firm, false, 'col-sm-12', null, readonly, 100),
                _this.createInput('companyNumber', Resx.Common.CompanyNumber, false, 'col-sm-6', null, readonly, 14),
                _this.createInput('vatNumber', Resx.Common.VatNumber, false, 'col-sm-6', null, readonly, 19)
            );
        };

        _this.anonymous = !!anonymous;
        return _this;
    }

    (0, _createClass3.default)(UserContactsBase, [{
        key: 'changeState',
        value: function changeState(field, value) {
            this.props.changeContact((0, _defineProperty3.default)({}, field, value));
        }
    }, {
        key: 'createInput',
        value: function createInput(field, label, isRequired, className, icon, readonly, maxLength) {
            var _this2 = this;

            var errors = this.props.contactErrors;
            return _react2.default.createElement(_FormInput2.default, {
                name: field,
                value: this.props.contact[field],
                label: label,
                isRequired: isRequired,
                className: className,
                icon: icon,
                maxLength: maxLength,
                disabled: !!readonly,
                error: errors.clientErrors[field] || errors.serverErrors[field],
                onChange: function onChange(e) {
                    return _this2.changeState(field, e.target.value);
                } });
        }
    }]);
    return UserContactsBase;
}(_react2.default.PureComponent), _class.propTypes = {
    contact: _propTypes2.default.object,
    changeContact: _propTypes2.default.func
}, _temp);
exports.default = UserContactsBase;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step3/UserContactsBase.js
// module id = 753
// module chunks = 0